import { useQueries } from '@tanstack/react-query';

import { getTermsAcceptanceStatus } from '@/services/terms';

export const TERMS_ACCEPTANCE_STATUS_QUERY_KEY = 'terms-acceptance-status';

export default function useTermsAcceptanceStatuses({
  docIds,
  enabled,
}: {
  docIds: string[];
  enabled: boolean;
}) {
  const results = useQueries({
    queries: docIds.map((docId) => ({
      queryKey: [TERMS_ACCEPTANCE_STATUS_QUERY_KEY, docId],
      queryFn: () => getTermsAcceptanceStatus({ terms_document_id: docId }),
      enabled,
      refetchOnMount: true,
    })),
  });

  const acceptedVersions: Record<string, number | null> = {};
  for (const result of results) {
    if (result.data) {
      acceptedVersions[result.data.terms_document_id] =
        result.data.last_accepted_version;
    }
  }

  const isFetching = results.some((result) => result.isFetching);

  return { acceptedVersions, isFetching };
}
